import React from 'react';
import { Descriptions, Typography } from 'antd';
import Markdown from 'react-markdown';
import { replaceBrWithNewline, formatSize } from '../../utils/utils';
import { locale } from '../../api/config';
import styles from './index.module.less';
import { FormattedMessage } from 'react-intl';

const { Paragraph } = Typography;

const FileDetail = ({ data }) => {
  const { name, file_name, version, products, desc, checksum, release_note, category } = data;
  const displayName = category === "Manuals" || category === "Brochures" ? name : file_name;
  return (
    <div className={styles.file_detail}>
      <Descriptions labelStyle={{ fontWeight: 550 }}>
        <Descriptions.Item
          label={
            <strong>
              {' '}
              <FormattedMessage id='FileName' />
            </strong>
          }
        >
          {displayName || '-'}
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <strong>
              {' '}
              <FormattedMessage id='Version' />
            </strong>
          }
        >
          {version || '-'}
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <strong>
              {' '}
              <FormattedMessage id='Size' />
            </strong>
          }
        >
          {formatSize(data.size) || '-'}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        column={1}
        labelStyle={{ fontWeight: 550 }}
        layout='vertical'
      >
        <Descriptions.Item
          label={
            <strong>
              {' '}
              <FormattedMessage id='Products' />
            </strong>
          }
          contentStyle={{ display: 'block' }}
        >
          <Paragraph
            className={styles.ten}
            ellipsis={{
              rows: 2,
              expandable: true,
              symbol: 'more',
            }}
          >
            {products.join(' , ') || '-'}
          </Paragraph>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <strong>
              {' '}
              <FormattedMessage id='Descriptions' />
            </strong>
          }
        >
          <div className={styles.ten}> {desc[locale] || '-'}</div>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <strong>
              {' '}
              <FormattedMessage id='ReleaseNotes' />
            </strong>
          }
        >
          <div className={styles.release_note}>
            <Markdown>{replaceBrWithNewline(release_note[locale])}</Markdown>
          </div>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <strong>
              {' '}
              <FormattedMessage id='Checksum' />
            </strong>
          }
        >
          <div className={styles.ten}>{checksum || '-'}</div>
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default FileDetail;
